import useAuth from "../hooks/useAuth";

function PrivateRoute({ children }: any) {

    const { isAuthenticated, signinRedirect, logout } = useAuth();

    if (isAuthenticated()) {
        return children;
    } else {
        signinRedirect();
        return <div>Redirecionando para login...</div>
    }
}

export default PrivateRoute;
